import { useTranslation } from "react-i18next";

import { HEIGHT } from "~/shared/lib/design-tokens";
import { cn } from "~/shared/lib/utils";
import { Button } from "~/shared/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/shared/ui/tooltip";

interface SendButtonProps {
    costLabel: string;
    canSend: boolean;
    /**
     * Почему кнопка не работает — готовый текст подсказки; null, когда она рабочая.
     *
     * Причин несколько (не хватает обязательных кадров, кадр нужен и вместе с
     * элементами, набор входов никто не исполняет), и различает их владелец бара:
     * у него есть и состояние, и переводчик. Кнопке достаточно одной строки —
     * иначе каждая новая причина добавляла бы сюда ещё один флаг.
     */
    blockedHint: string | null;
    onSend: () => void;
}

const SEND_BTN_CLASS = cn(
    HEIGHT.sendBtn,
    "rounded-xl bg-white px-5 text-sm font-semibold text-zinc-900 tabular-nums",
    "hover:bg-zinc-200",
    "disabled:cursor-not-allowed disabled:opacity-40",
);

export function SendButton({ costLabel, canSend, blockedHint, onSend }: SendButtonProps) {
    const { t } = useTranslation("chat");
    const button = (
        <Button
            type="button"
            size="sm"
            onClick={onSend}
            disabled={!canSend}
            aria-label={`${t("prompt.generate")} ${costLabel}`}
            className={SEND_BTN_CLASS}
        >
            {costLabel}
        </Button>
    );
    if (blockedHint === null) return button;
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span>{button}</span>
            </TooltipTrigger>
            <TooltipContent>{blockedHint}</TooltipContent>
        </Tooltip>
    );
}
